import {
    ALL_MONTHS,
    MonthValue,
    PlayHistoryRangeSelection,
    monthEnd,
    monthStart,
} from '../components/PlayHistoryRangePicker';
import { PlayHistoryRange } from '../hooks/use-play-history';

export const formatRangeMonth = (month: MonthValue, fallbackMonth: number) => {
    const monthIndex = (month === ALL_MONTHS ? fallbackMonth : month) - 1;
    return new Date(0, monthIndex).toLocaleString('default', { month: 'short' });
};

export const selectionToRange = (selection: PlayHistoryRangeSelection): PlayHistoryRange => ({
    fromYear: selection.fromYear,
    fromMonth: monthStart(selection.fromMonth),
    toYear: selection.toYear,
    toMonth: monthEnd(selection.toMonth),
});

export const getRangeLabel = (selection: PlayHistoryRangeSelection) =>
    `${formatRangeMonth(selection.fromMonth, 1)} ${selection.fromYear} - ${formatRangeMonth(selection.toMonth, 12)} ${
        selection.toYear
    }`;
